module.exports = __webpack_public_path__ + "img/Category.7c2f802f.svg";